import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer>
      <p>A portfolio designed & built by Energygo</p>
      <p>Contact us! office@energygo.at / +4369010011961 </p>
    </footer>
  );
}

export default Footer;